import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/platformAuthStore';
import { theme } from '../theme';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 56px)',
    padding: '40px 20px',
    textAlign: 'center' as const,
  },
  hero: {
    maxWidth: '640px',
  },
  title: {
    fontFamily: "'Pixelify', sans-serif",
    fontSize: '48px',
    fontWeight: 800,
    lineHeight: 1.1,
    color: theme.textBright,
    marginBottom: '16px',
  },
  subtitle: {
    fontSize: '20px',
    color: theme.textSecondary,
    lineHeight: 1.5,
    marginBottom: '32px',
  },
  features: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '24px',
    maxWidth: '800px',
    margin: '48px auto 0',
  },
  feature: {
    padding: '24px',
    background: theme.bgPanel,
    borderRadius: theme.radiusLg,
    border: `1px solid ${theme.border}`,
    textAlign: 'left' as const,
  },
  featureTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.textPrimary,
    marginBottom: '8px',
  },
  featureDesc: {
    fontSize: '14px',
    color: theme.textMuted,
    lineHeight: 1.5,
  },
  cta: {
    padding: '12px 32px',
    borderRadius: theme.radiusLg,
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 600,
    background: theme.accent,
    color: theme.accentText,
  },
};

const features = [
  {
    title: 'Visual Map Editor',
    desc: 'Build expansive worlds with our tile-based editor. Multiple layers, auto-tiles, and real-time preview.',
  },
  {
    title: 'Real-Time Multiplayer',
    desc: 'Powered by Colyseus - authoritative server, low-latency networking, automatic state sync.',
  },
  {
    title: 'Complete RPG Systems',
    desc: 'Classes, spells, items, crafting, NPCs, quests, guilds, housing - all built in and customizable.',
  },
];

export function Landing() {
  const navigate = useNavigate();
  const token = useAuthStore((s) => s.token);

  return (
    <div style={styles.container}>
      <div style={styles.hero}>
        <h1 style={styles.title}>Lune</h1>
        <p style={styles.subtitle}>
          A full RPG maker in your browser. Build maps, quests, NPCs and items, then play it online
          with friends.
        </p>
        <button style={styles.cta} onClick={() => navigate(token ? '/dashboard' : '/signup')}>
          {token ? 'Go to Dashboard' : 'Get Started Free'}
        </button>
      </div>

      <div style={styles.features}>
        {features.map((f) => (
          <div key={f.title} style={styles.feature}>
            <div style={styles.featureTitle}>{f.title}</div>
            <div style={styles.featureDesc}>{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
